import {
  useState, useCallback, useEffect, useContext
} from 'react';

import {
  getDigestionItemsForSpecialHoliday,
  downloadSpecialHolidayDigestionCsv,
  getSpecialHolidayDigestionDetail,
} from 'api/holidayManagement';
import moment from 'moment';
import SpecialHolidayDigestionDomain from 'domain/master/holidayManagement/specialHolidayDigestion';
import useToastNotification from 'hooks/useToastNotification';
import { HolidayManagementContext } from './../../HolidayManagementForm'

export interface DetailItems {
  cnt: string,
  orgCode: string,
  orgName: string,
  staffCode: string,
  staffName: string,
  holidayCode: string,
  holidayName: string,
  total: string,
  specialHolidayDigestionDetailList: [],
  fromDate: Date,
  toDate: Date,
}

export const useAcquisitionStatusDomainForm = () => {
  const sessionStorageOrgCode = sessionStorage.getItem('loginUser.orgCode') || '';
  const [paidHolidayDigestedtHistoryList, setPaidHolidayDigestedtHistoryList] = useState<Array<SpecialHolidayDigestionDomain>>([]);
  const [noManager, setNoManager] = useState(false);
  const [orgCode, setOrgCode] = useState(sessionStorageOrgCode);
  const [searchDate, setSearchDate] = useState<Date>(new Date());
  const [modalOpen, setModalOpen] = useState(false);
  const [detailItems, setDetailItems] = useState<DetailItems>({
    cnt: '',
    orgCode: '',
    orgName: '',
    staffCode: '',
    staffName: '',
    holidayCode: '',
    holidayName: '',
    total: '',
    specialHolidayDigestionDetailList: [],
    fromDate: new Date(),
    toDate: new Date(),
  });
  const { errorNotification } = useToastNotification();

  const contextObject = useContext(HolidayManagementContext);

  // データの取得
  const fetchData = useCallback(async () => {
    contextObject.setIsLoading(true);
    const response = await getDigestionItemsForSpecialHoliday(
      orgCode !== 'all' ? orgCode : '',
      String(moment(moment(searchDate).toDate()).format('YYYY/MM/DD')),
    );
    contextObject.setIsLoading(false);
    setPaidHolidayDigestedtHistoryList(response.map((result) => new SpecialHolidayDigestionDomain(result)));
  }, [orgCode, searchDate]);

  useEffect(() => {
    fetchData();
  }, [fetchData, noManager, orgCode, searchDate]);

  const toggleNoManager = useCallback(() => {
    setNoManager(!noManager);
  }, [noManager]);

  const closeModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  //
  const callGetAcquisitionStatusDetail = useCallback(async (staffCode: string) => {
    try {
      await getSpecialHolidayDigestionDetail(
        staffCode,
        String(moment(moment(searchDate).toDate()).format('YYYY/MM/DD')),
      ).then((response: any) => {
        setDetailItems(response);
      });
    } catch (error) {
      if (error.response && error.response.data && error.response.data.errors) {
        const listErr = error.response.data.errors;
        listErr.map((element: any) => errorNotification(element.defaultMessage));
      } else {
        errorNotification('サーバー側でエラーが発生しました。');
        throw error;
      }
    }
  }, [errorNotification, searchDate]);

  return {
    paidHolidayDigestedtHistoryList,
    callGetAcquisitionStatusDetail,
    toggleNoManager,
    orgCode,
    setOrgCode,
    searchDate,
    setSearchDate,
    modalOpen,
    setModalOpen,
    closeModal,
    detailItems,
    setDetailItems,
  };
};

export const useDownloadHolidayManagementAcquisitionStatus = (
  orgCode: string,
  targetDate: Date,
) => {
  const [blocking, setBlocking] = useState(false);
  const downloadHolidayManagementAcquisitionStatus = useCallback((isDownloadAll?: boolean) => {
    setBlocking(true);
    downloadSpecialHolidayDigestionCsv(
      isDownloadAll ? '' : orgCode,
      targetDate,
    ).then(() => { 
      setBlocking(false);
    });
  }, [orgCode, targetDate]);

  return {
    blocking,
    downloadHolidayManagementAcquisitionStatus
  };
};

export default {
  useAcquisitionStatusDomainForm,
};
